import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { HeaderPibankComponent } from './shared/components/header-pibank/header-pibank.component';
import { NotificationComponent } from './vass-core/components/notification/notification.component';

import { environment } from '../environments/environment';
import { NotificationModel } from './vass-core/components/notification/notificationModel.interface';

import { PrimeNG } from 'primeng/config';
import { AuthService } from './shared/services/auth/auth.service';
import { CommonService } from './vass-core/services/common.service';

declare const require: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  @ViewChild('notification', { static: true })
  notification: NotificationComponent;
  @ViewChild('header', { static: true }) header: HeaderPibankComponent;

  public version: string = require('../../package.json').version;
  public isLogged: boolean;

  constructor(
    private commonService: CommonService,
    private translSrv: TranslateService,
    private authService: AuthService,
    private router: Router,
    private primeNGConfig: PrimeNG,
  ) {
    this.translSrv.setDefaultLang('es');
    this.translSrv.use('es');
    this.isLogged = !!sessionStorage.getItem('token');

    this.translSrv.get('web_config_calendar_object').subscribe((resp) => {
      const config = JSON.parse(resp.replace(/'/g, '"'));
      this.primeNGConfig.setTranslation(config);
    });
  }

  ngOnInit(): void {
    this.updateInitialStatus();
    this.showCurrentVersion();
    this.displayNotification();
    this.routerListener();

    this.authService.changesOnOpenmodalLogin().subscribe((open) => {
      if (open) {
        this.header.recoverRequest();
      }
    });
  }

  private updateInitialStatus() {
    this.authService.updateStatus(true);
  }

  private displayNotification() {
    this.commonService.notificationEv$.subscribe(
      (notificationModel: NotificationModel) => {
        if (notificationModel.severity) {
          this.notification[notificationModel.severity](notificationModel);
        }
      },
    );
  }

  private routerListener() {
    this.router.events.subscribe((event: any) => {
      window.scrollTo(0, 0);
      this.authService.reloadTimeoutLogout();
      this.isLogged = !!sessionStorage.getItem('token');
    });
  }

  private showCurrentVersion() {
    if (!environment.showVersion) {
      console.log(`Version: ${this.version}`);
    }
  }
}
